<template>
  <div>
    <v-table
        fixed-header
        height="500px"
    >
      <thead>
      <tr>
        <th style="width: 60%;"><h4>Title</h4></th>
        <th style="width: 10%;"><h4><v-icon icon="mdi-clock" /></h4></th>
        <th style="width: 20%;"><h4>Username</h4></th>
        <th v-if="!publicqueue" style="width: 10%;"><h4>Actions</h4></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in items" :key="index">
        <td>{{ item.title }}</td>
        <td>
          {{ moment.utc().startOf('day').add(moment.duration(item.duration, 's')).format('mm:ss') }}
        </td>
        <td>{{ item.requester }}</td>
        <td v-if="!publicqueue">
          <v-tooltip location="top" :text="$t('delete')">
            <template v-slot:activator="{ props }">
              <v-btn
                  size="x-small"
                  v-bind="props"
                  icon="mdi-delete"
                  color="error"
                  class="mr-1 ml-1"
                  :variant="utils.buttonIconVariant"
                  @click="emit('remove', item)"
              ></v-btn>
            </template>
          </v-tooltip>
        </td>
      </tr>
      </tbody>
    </v-table>
  </div>
</template>

<script setup>
import moment from 'moment/moment';

const emit = defineEmits(['delete']);

defineProps({
  items: {
    type: Array,
    required: true,
  },
  publicqueue: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped>

</style>
